import { z } from 'zod';

const siteSchema = z.object({
  id: z.string(),
  displayName: z.string(),
  viewUrl: z.union([z.string().url(), z.literal('')]).optional(),
});

export const querySitesSchema = z.object({
  sites: z.array(siteSchema),
});

export type Site = z.TypeOf<typeof siteSchema>;
